export const onAdd = () => ({
  widget: 'tokens',
  type: 'onAdd',
  payload: {},
})



// WEBPACK FOOTER //
// ./src/tokens/actions/onAdd.js